import { render, staticRenderFns } from "./ShareDiscussCourse.vue?vue&type=template&id=9753fede"
import script from "./ShareDiscussCourse.vue?vue&type=script&lang=js"
export * from "./ShareDiscussCourse.vue?vue&type=script&lang=js"
import style0 from "./ShareDiscussCourse.vue?vue&type=style&index=0&id=9753fede&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports